var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.60795C14.6393 2.60795 17.8848 4.65324 19.4692 7.8892C17.8848 11.1252 14.6489 13.1705 11 13.1705C7.35114 13.1705 4.11517 11.1252 2.5308 7.8892C4.11517 4.65324 7.36074 2.60795 11 2.60795ZM11 0.6875C6.19886 0.6875 2.09869 3.67381 0.4375 7.8892C2.09869 12.1046 6.19886 15.0909 11 15.0909C15.8011 15.0909 19.9013 12.1046 21.5625 7.8892C19.9013 3.67381 15.8011 0.6875 11 0.6875ZM11 5.48864C12.3251 5.48864 13.4006 6.56409 13.4006 7.8892C13.4006 9.21432 12.3251 10.2898 11 10.2898C9.67489 10.2898 8.59943 9.21432 8.59943 7.8892C8.59943 6.56409 9.67489 5.48864 11 5.48864ZM11 3.56818C8.61864 3.56818 6.67898 5.50784 6.67898 7.8892C6.67898 10.2706 8.61864 12.2102 11 12.2102C13.3814 12.2102 15.321 10.2706 15.321 7.8892C15.321 5.50784 13.3814 3.56818 11 3.56818Z",
    fill: "#1D5E6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.2618ea11e4428abb652dc8bc2ff0d936.svg";
export { ForwardRef as ReactComponent };